class SsoRegister extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleMarketing = this.handleMarketing.bind(this)
    this.listeners.add(
      this.els.marketing.element,
      'change',
      this.handleMarketing,
    )

    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.listeners.add(this.els.form.element, 'submit', this.handleFormSubmit)
  }

  handleMarketing (event) {
    if (event.currentTarget.checked) {
      this.els.ometria.element.setAttribute('name', 'customer[tags]')
    } else {
      this.els.ometria.element.removeAttribute('name')
    }
  }

  async handleFormSubmit (event) {
    event.preventDefault()

    try {
      const response = await fetch(window.theme.sso.register, {
        method: 'POST',
        body: window.BAO.Utils.serialize(this.els.form.element),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      const data = await response.json()

      const responseMessage = data.response.message

      /**
       * Handle errors.
       */
      if (responseMessage !== 'customer_created') {
        const errorsResponse = JSON.parse(data.response.text)

        let errorMessage = ''

        if (errorsResponse.code && errorsResponse.code === 'invalid_password') {
          const policy = errorsResponse.policy.replace(/\* /g, '<br>')
          errorMessage = `${errorsResponse.message}<br>${policy}`
        } else if (
          errorsResponse.code &&
          errorsResponse.code === 'invalid_signup'
        ) {
          errorMessage = window.theme.sso.register_error
        } else {
          errorMessage =
            errorsResponse.message ||
            errorsResponse.description ||
            errorsResponse.error
        }

        this.els.errors.element.innerHTML = `<p class="frm-Form_ValidationText frm-Form_ValidationText-error">${errorMessage}</p>`
        this.els.errors.element.setAttribute('aria-hidden', false)
        return
      }

      this.els.errors.element.setAttribute('aria-hidden', true)
      this.els.fields.element.setAttribute('aria-hidden', true)
      this.els.success.element.setAttribute('aria-hidden', false)

      this.els.form.element.reset()

      this.handleGtm('account_register')
    } catch (error) {
      this.els.errors.element.innerHTML = `<p class="frm-Form_ValidationText frm-Form_ValidationText-error">${window.theme.sso.error}</p>`

      throw new Error('Could not register customer', error)
    }
  }

  handleGtm (action) {
    const dataLayer = window.dataLayer || []
    const event = action

    dataLayer.push({
      event,
    })
  }
}

if (!customElements.get('sso-register')) {
  customElements.define('sso-register', SsoRegister)
}
